<script>
	import PageSection from "../../components/PageSection.svelte";
	import PersonalDetails from "./PersonalDetails.svelte";
	import Details from "./Details.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import Checkbox from "../../components/Checkbox.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let nextPageLabel = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;
	export let title = null;

	if ($pageNumber == pageIndex + 1) {
		alert("Your registration has already been submitted.");
		window.location.href = window.basePath;
	} else {
		pageNumber.update((p) => pageIndex);
	}

	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;
	function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(`;`).shift();
		else return false;
	}

	// fetches google id by ga or cookie
	function getGoogleID() {
		let googleID = null;
		if (typeof window.ga === `function` && typeof window.ga.getAll === `function`)
			googleID = window.ga.getAll()[0].get(`clientId`);
		else if (getCookie(`_ga`)) {
			let str = getCookie(`_ga`);
			str = str.slice(6);
			googleID = str;
		}
		return googleID;
	}

	const onSubmit = () => {
		if (typeof window !== "undefined" && typeof window.analytics === "object") {
			const properties = {
				category: "Form",
				label: projectSettings.classActionName
			};
			const gaid = getGoogleID();
			// if google id adds ga id to tracks
			if (gaid) properties.gaid = gaid;
			window.analytics.track("Class Action Form Submitted", properties);
		}
	};

	let confirmed = false;
</script>

{#if $pageNumber == pageIndex}
	<PageSection>
		<h1>Confirmation</h1>
		<p>Please check the below details are correct before submitting your registration.</p>
		<form>
			<PersonalDetails disabled="true"></PersonalDetails>
			<Details disabled="true"></Details>

			<div class="form-row">
				<div class="col-md-8 col-sm-12">
					<Checkbox
						required="true"
						bind:checked={confirmed}
						label="I confirm that all information provided in this section is true and correct."
						id="confirmation"
					></Checkbox>
				</div>
			</div>

			<div class="form-row">
				<div class="col-md-12 last">
					<NavigationButtons
						{persistUrl}
						{previousPage}
						{nextPage}
						{nextPageLabel}
						tealiumTag={true}
						pageName={title}
					>
						{onSubmit}
					</NavigationButtons>
				</div>
			</div>
		</form>
	</PageSection>
{/if}
